import React from 'react';
import { useParams } from 'react-router-dom';
import { LoadingPage } from 'components/loading';
import { ErrorPage } from 'components/errors';
import { usePlanInactive } from 'hooks/use-plan-inactive.hook';
import { Active } from './active';
import { Closed } from './closed';

export const WithUtilityAccounts = () => {
  const { planId } = useParams<{ planId?: string }>();
  const { data, loading, error } = usePlanInactive({
    planId: Number(planId),
  });

  if (loading) return <LoadingPage dataTestId="with-utility-accounts" />;
  if (error || !data) return <ErrorPage />;

  return data.planInactive ? <Closed /> : <Active />;
};
